import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'
import { mapLoyaltyEsimBenefit } from 'api/mappers/loyalty/mapLoyaltyEsimBenefit'

type SuccessResponse = paths['/api/lux-loyalty/esim/orders']['get']['responses']['200']['content']['application/json']

export default async function requestLoyaltyEsimBenefits(customerId: string): Promise<Array<App.LoyaltyEsimBenefit>> {
  const response = await requestUtils.get<SuccessResponse>(
    `/api/lux-loyalty/esim/orders?customerId=${customerId}`,
    { credentials: 'include' },
  )
  return response.result.orders.map(mapLoyaltyEsimBenefit)
}
